import { useSelector } from "react-redux";
import { getTrialInfo } from "selectors/userInfo";
import { PAYMENT_CONFIG } from "constants/payment";
import { PaymentModal } from "../PaymentModal";

/**
 * Блокирующий оверлей для неоплативших пользователей
 * после окончания пробного периода
 */
const PaymentBlockOverlay = () => {
	const trialInfo = useSelector(getTrialInfo);

	// Использование демо-данных или реальных из Redux
	const daysRemaining = PAYMENT_CONFIG.DEMO_MODE
		? PAYMENT_CONFIG.DEMO_DAYS
		: trialInfo.daysRemaining;
	const isPayed = PAYMENT_CONFIG.DEMO_MODE
		? PAYMENT_CONFIG.DEMO_IS_PAYED
		: trialInfo.isPayed;

	// Не показываем оверлей для оплативших пользователей
	if (isPayed) return null;

	// Показываем только после окончания trial периода
	if (daysRemaining > 0) return null;

	return (
		<PaymentModal
			variant="block"
			title="Бесплатный период закончился"
			description="Для продолжения обучения и доступа ко всем материалам необходимо оплатить доступ"
		/>
	);
};

export default PaymentBlockOverlay;
